import Icon from '@ant-design/icons';
import React from 'react';
import { ReactComponent as IconSvg } from '../../assets/FileAlertOutlined.svg';

export const FileAlertOutlined = (props: React.ComponentProps<typeof Icon>) => {
  return <Icon component={IconSvg} {...props} />;
};
